import { DialogsSection } from './DialogsSection'

export default DialogsSection
